import FeedbackModalCard from './FeedbackModalCard'

export default FeedbackModalCard
